import { useEffect, useState } from 'react'

import ListingAlertPopup from 'src/shared/features/alert/listing-alert-popup'

const LISTING_ALERT_POPUP_STORAGE_KEY = 'conrad-listing-alert-popup-shown'

const TIMEBEFORE_POPUP_OPEN_MS = 3000

/**
 * Wraps routes and auto-opens the ListingAlertPopup after a short delay.
 * A localStorage flag prevents the popup from showing again on refresh.
 */
export default function AutoPopupProvider({ children }: { children: React.ReactNode }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.localStorage.getItem(LISTING_ALERT_POPUP_STORAGE_KEY)) return

    const timer = window.setTimeout(() => {
      setIsPopupOpen(true)
      window.localStorage.setItem(LISTING_ALERT_POPUP_STORAGE_KEY, 'true')
    }, TIMEBEFORE_POPUP_OPEN_MS)

    return () => window.clearTimeout(timer)
  }, [])

  /**
   * Syncs popup open state and persists the "shown" flag when opened.
   */
  const handleOpenChange = (nextOpen: boolean) => {
    setIsPopupOpen(nextOpen)

    if (nextOpen && typeof window !== 'undefined') {
      window.localStorage.setItem(LISTING_ALERT_POPUP_STORAGE_KEY, 'true')
    }
  }

  return (
    <>
      {children}
      <ListingAlertPopup open={isPopupOpen} setOpen={handleOpenChange} />
    </>
  )
}
